import React from 'react';
import styled, { css } from 'styled-components';

export interface TextAndIconButtonProps {
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  style?: React.CSSProperties;
  testId?: string;
  disabled?: boolean;
}

export const TextAndIconButton: React.FC<TextAndIconButtonProps> = ({
  children,
  onClick,
  style,
  testId,
  disabled,
  ...props
}) => {
  return (
    <TextAndIconButtonStyled
      onClick={onClick}
      style={style}
      data-testid={testId}
      disabled={disabled}
      {...props}
    >
      {children}
    </TextAndIconButtonStyled>
  );
};

const TextAndIconButtonStyled = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  color: ${({ theme }) => theme.atlas.semantic.color.type.default};
  font-weight: 500;
  font-size: 9px;
  line-height: 10px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  padding: 3px 6px;
  gap: 4px;
  background: ${({ theme }) => theme.atlas.semantic.color.outline.default};
  border-radius: 4px;
  width: fit-content;
  cursor: pointer;
  z-index: 1;
  border: none;
  ${(props) =>
    props.disabled &&
    css`
      background-color: ${props.theme.atlas.semantic.color.outline.default};
      border: 1px solid ${props.theme.atlas.semantic.color.outline.default};
      &:hover {
        cursor: not-allowed;
      }
    `}
`;
